import React from "react";
import { StateContextType } from "../types/state.types";

const MainStateContext = React.createContext<StateContextType | null>(null);

export default MainStateContext;
